const tokenNameRegs = [
    { expr: /[a-z]*-qa-api.morningstar.com/, name: 'apiGatewayToken', environment: 'qa' },
    { expr: /[a-z]*-uat-api.morningstar.com/, name: 'apiGatewayToken', environment: 'uat' },
    { expr: /[a-z]*-stg-api.morningstar.com/, name: 'apiGatewayToken', environment: 'stage' },
    { expr: /[a-z]*-api.morningstar.com/, name: 'apiGatewayToken', environment: 'prod' },
    { expr: /markets-uat.morningstar.com/, name: 'marketsApiToken', environment: 'uat' },
    { expr: /quotespeed.morningstar.com/, name: 'marketsApiToken', environment: 'prod' },
    { expr: /api.morningstar.com/, name: 'accessToken', environment: 'prod' },
    { expr: /euiwtqademo.morningstar.com/, name: 'demo', environment: 'qa' },
];

/**
 * Returns tokenName URL for the specified params
 * @return {string} token name URL
 */
const getTokenNameByUrl = function getTokenNameByUrl(url) {
    if (!url) {
        return null;
    }

    for (let i = 0; i < tokenNameRegs.length; i += 1) {
        if (tokenNameRegs[i].expr.test(url)) {
            return tokenNameRegs[i];
        }
    }
    return null;
};

export { getTokenNameByUrl as default };



// WEBPACK FOOTER //
// ./src/api-token-helper.js